import React, { useContext, useState } from 'react';
import { LayerGroup, LayersControl, Marker, Tooltip, useMapEvent } from 'react-leaflet';
import { getLayerLabel, splitPoints } from 'actions/spectrumActions';
import LocaleContext from '../../constants/localization';
import { dot_orange } from '../../map/icon';

/**
 * Implements a LayerGroup overlay which displays building ID information from
 * a WFS service via wfs.do
 */
export default function WFSBuildingsLayer({layerDetail}) {
  const [wfsResults, setWfsResults] = useState({});
  const LS = useContext(LocaleContext);

  const map = useMapEvent('moveend', () => {
    getBuildingsFromWFS(map.getBounds(), map.getZoom());
  });

  const getBuildingsFromWFS = (bounds, zoomLevel) => {
    if (zoomLevel <= 10) {
      setWfsResults({});
      return;
    }

    const lowerCorner = bounds.getSouthEast();
    const upperCorner = bounds.getNorthWest();

    fetch(`wfs.do?lowerCornerX=${lowerCorner.lng}&lowerCornerY=${lowerCorner.lat}&upperCornerX=${upperCorner.lng}&upperCornerY=${upperCorner.lat}`)
      .then(res => res.json())
      .then(res => setWfsResults(res));
  };

  return (
    <LayersControl.Overlay name={getLayerLabel(layerDetail, LS.getLanguage())}>
      <LayerGroup>
        {
          Object.keys(wfsResults).map((id, i) => {
            const position = splitPoints([wfsResults[id]], false)[0];
            return (
              <Marker
                position={position}
                icon={dot_orange}
                key={i}>
                <Tooltip>{id}</Tooltip>
              </Marker>
            )
          })
        }
      </LayerGroup>
    </LayersControl.Overlay>
  );
}